module.exports = __webpack_public_path__ + "static/img/img-sing-up-top-phone.1a55363.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-sing-up-top-phone.png
// module id = 456
// module chunks = 2